import "./mobileApp.css";
import Nav from "./Nav";
import Footer from "./Footer";

const appScreens = [
  {
    image: require("../images/appImages/app-order.webp"),
    title: "Order your favourites",
  },
  {
    image: require("../images/appImages/app-points.webp"),
    title: "Earn points as you go",
  },
  {
    image: require("../images/appImages/app-history.webp"),
    title: "Keep track of your points",
  },
  {
    image: require("../images/appImages/app-scan.webp"),
    title: "Scan and collect",
  },
  {
    image: require("../images/appImages/app-stores.webp"),
    title: "Find your nearest store",
  },
];

export default function MobileApp() {
  return (
    <section className="app-page">
      <Nav />
      <main>
        <section className="app-hero">
          <div className="app-hero-glow" aria-hidden="true" />
          <div className="app-hero-inner">
            <div className="app-content">
              {/* <span className="app-eyebrow">RaceTrack & Tubbees</span> */}
              <h1>RaceTrack<br />&amp; Tubbees</h1>
              <p>
                Get more from every visit. Order your favourites, collect points
                and find your nearest RaceTrack or Tubbees in one handy app.
              </p>
              <div className="app-benefits" aria-label="App benefits">
                <span>Earn points</span>
                <span>Order online</span>
                <span>Find a store</span>
              </div>
              <div className="store-links">
                <a href="https://play.google.com/store/apps/details?id=com.tubbees" target="_blank" rel="noopener noreferrer">
                  <img src="/google-play-badge.png" alt="Get it on Google Play" />
                </a>
                <a href="https://apps.apple.com/gb/app/tubbees-loyalty/id6738990046" target="_blank" rel="noopener noreferrer">
                  <img src="/app-store-badge.svg" alt="Download on the App Store" />
                </a>
              </div>
              <span className="app-available">Free to download · Available on iOS and Android</span>
            </div>
            <div className="app-feature-art">
              <span className="app-art-orbit app-art-orbit-one" aria-hidden="true" />
              <span className="app-art-orbit app-art-orbit-two" aria-hidden="true" />
              <img src={appScreens[0].image} alt="Tubbees app menu and online ordering screen" />
              <div className="app-art-tag"><span>01</span> All your favourites, in one place</div>
            </div>
          </div>
        </section>

        <section className="app-showcase" aria-labelledby="app-showcase-title">
          <div className="app-showcase-heading">
            <div>
              <span className="app-section-kicker">Made for your next stop</span>
              <h2 id="app-showcase-title">Good things add up.</h2>
            </div>
            <p>From your first scan to your next treat, it’s all in the app.</p>
          </div>
          <div className="app-screen-gallery">
            {appScreens.slice(1).map((screen, index) => (
              <article className="app-screen-card" key={screen.title}>
                <div className="app-screen-image">
                  <img src={screen.image} alt={`${screen.title} in the Tubbees app`} loading="lazy" />
                </div>
                <div className="app-screen-caption">
                  <span>0{index + 2}</span>
                  <h3>{screen.title}</h3>
                </div>
              </article>
            ))}
          </div>
          <div className="app-bottom-cta">
            <p>Ready to make every visit count?</p>
            <a href="#top" onClick={(event) => { event.preventDefault(); window.scrollTo({ top: 0, behavior: "smooth" }); }}>
              Get the app <span aria-hidden="true">↑</span>
            </a>
          </div>
        </section>
      </main>
      <Footer />
    </section>
  );
}
